import { Link } from "react-router-dom";
import { footerCategories, footerLinks, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-shield-keyhole-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">{siteInfo.fullName}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200 max-w-md">
              {siteInfo.name}是一条以隐私保护为前提的匿名信息通道。我们不要求你留下真实身份，也不鼓励你提供任何可识别个人的信息，只需要你愿意说出的那部分事实。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs bg-primary-900 text-primary-100 border border-primary-800">
                <i className="ri-eye-off-line" aria-hidden="true"></i>
                匿名提交
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs bg-primary-900 text-primary-100 border border-primary-800">
                <i className="ri-delete-bin-6-line" aria-hidden="true"></i>
                不长期留存
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs bg-primary-900 text-primary-100 border border-primary-800">
                <i className="ri-file-shield-2-line" aria-hidden="true"></i>
                保密处理
              </span>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              <Link to="/" className="hover:text-accent-300 transition-colors">网站导航</Link>
            </h4>
            <ul className="space-y-3 text-sm">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-background-200 hover:text-accent-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">可受理类型</h4>
            <ul className="space-y-3 text-sm">
              {footerCategories.slice(0, 5).map((item) => (
                <li key={item} className="text-background-200">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">联系我们</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="inline-flex items-start gap-2 text-background-200 hover:text-accent-300 transition-colors break-all"
                >
                  <i className="ri-mail-line mt-0.5" aria-hidden="true"></i>
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-background-200">
                <i className="ri-time-line mt-0.5" aria-hidden="true"></i>
                <span>回复周期约 {siteInfo.replyWindow}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            © {year} {siteInfo.fullName}。请仅提交你亲身了解或能够佐证的信息。
          </p>
          <p className="text-xs text-background-300 flex items-center gap-2">
            <i className="ri-information-line" aria-hidden="true"></i>
            本站为匿名信息通道，不发布具体个案细节。
          </p>
        </div>
      </div>
    </footer>
  );
}